// extracted by mini-css-extract-plugin
export var content = "_5k-3";
export var list = "_5k-4";
export var settingsContent = "_5k-7";
export var settingsPanel = "_5k-8";
export var state = "_5k-6";
export var triggerBadge = "_5k-2";
export var triggerButton = "_5k-1";
export var triggerShell = "_5k-0";
export var unreadDot = "_5k-5";